// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66421903","239":"3c5ebedb","667":"5113e97e"}[chunkId] + ".chunk.js";
};